import { render, staticRenderFns } from "./GlobalConstantsRegistry.vue?vue&type=template&id=daedcc3c&scoped=true"
import script from "./GlobalConstantsRegistry.vue?vue&type=script&lang=js"
export * from "./GlobalConstantsRegistry.vue?vue&type=script&lang=js"
import style0 from "./GlobalConstantsRegistry.vue?vue&type=style&index=0&id=daedcc3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daedcc3c",
  null
  
)

export default component.exports